import styled from "styled-components";

export const HorizontalRuleAppointmentSummary = styled.hr`
  margin: 27px 0px;
  background-color: rgba(229, 229, 229, 1);
  opacity: 0.6;
`;
